export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.bbc585c8.png";